module.exports = __webpack_public_path__ + "img/canvas-bg9.06288c43.png";